/** Browser-only: SPA origin for resolving `/public` asset URLs in email preview. */
export function getSameOriginBaseUrl(): string | undefined {
  if (typeof globalThis === 'undefined' || !('location' in globalThis)) {
    return undefined;
  }
  const origin = (globalThis as { location?: { origin?: string } }).location?.origin;
  return origin && origin !== 'null' ? origin : undefined;
}
